<template>
  <div class="wrap-statistic">
    <head-view :option="title" :subtitleOpt="subtitleOpt"></head-view>
    <div class="statistics-content">
      <b-loading :is-full-page="true" :active.sync="$store.state.isLoader" :can-cancel="false"></b-loading>
      <div class="content__filters">
        
        <b-select name="buildings" placeholder="Elija Categoria" class="input-select-custom select-stats"
          v-model="category" v-if="$store.state.namespace === 'experience'">
          <option value>Todas-Categorias</option>
          <option :value="cat.value" v-for="cat of expCat" :key="cat.value">{{ cat.label }}</option>
        </b-select>
        <b-select name="buildings" placeholder="Elija Edificio" class="input-select-custom select-stats"
          v-model="building">
          <option value>Todos-Edificios</option>
          <option :value="edi.id" v-for="edi of $store.getters.listaEdificios" :key="edi.id">{{ edi.name }}</option>
        </b-select>
        <div class="dp-stat">
          <!-- <date-picker v-model="dateSelect" class="data-picker-custom" range lang="es" format="DD MMM YYYY" confirm @confirm="changeDate" placeholder="Todas la fechas"></date-picker> -->
          <template>
            <div>
              <div class="datepicker-trigger">
                <input class="input-date" type="text" id="datepicker-trigger" placeholder="Seleccione las fechas"
                  :value="formatDates(dateOne, dateTwo)">

                <AirbnbStyleDatepicker :trigger-element-id="'datepicker-trigger'" :mode="'range'"
                  :fullscreen-mobile="true" :date-one="dateOne" :date-two="dateTwo"
                  @date-one-selected="val => { dateOne = val }" @date-two-selected="val => { dateTwo = val }" />
              </div>
            </div>
          </template>
        </div>
        <button class="ripple btn-filter" @click="filterData">Filtrar</button>
        <button class="ripple btn-stats" @click="downloadExcel">Descargar Excel</button>
      </div>
      <section class="statistic-view__state" v-if="!isLoading">
        <div class="content-slideShow content-slideShow--progress">
          <h4 class="title-section">Estado General</h4>
          <progress-bar ancho="50px" :progreso="progressBar" />
        </div>
      </section>

      <div class="content__chart">
        <div id="myChart" ref="apexChart" class="charts"></div>
      </div>
      <div class="content__table" v-if="dataTable">
        <div class="wrapper-select wrapper-select--footer">
          <div class="table-section">
            <b-table class="table-history" :data="dataTable ? dataTable : []" :striped="isStriped" :narrowed="isNarrowed"
              :loading="$store.state.isLoader" default-sort-direction="asc">
              <template slot-scope="props">
                <b-table-column field="name" label="Punto de Control" width="400">{{ props.row.name }}</b-table-column>

                <b-table-column field="wellPercentage" label="Bien(%)" width="200" numeric>{{
                  Number(props.row.wellPercentage).toFixed(0) }}</b-table-column>

                <b-table-column field="badPercentage" label="Mal(%)" width="200" numeric>{{
                  Number(props.row.badPercentage).toFixed(0) }}</b-table-column>

                <b-table-column field="pendingPercentage" label="Pendiente(%)" width="200" numeric>{{
                  Number(props.row.pendingPercentage).toFixed(0) }}</b-table-column>
                <b-table-column field="standbyPercentage" label="Stand By(%)" width="200" numeric>{{
                  Number(props.row.standbyPercentage).toFixed(0) }}</b-table-column>
                <b-table-column field="action" width="400" centered>
                  <div class="table-button">
                    <a @click.stop.prevent="linkToView(props.row)" class="button-edit">ver detalles</a>
                  </div>
                </b-table-column>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                    </p>
                    <p>No hay datos.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import { mapState } from "vuex";
import ApexCharts from "apexcharts";
import progressBar from "../Componentes/progressBar";
import format from "date-fns/format";

export default {
  name: "Statistics",
  components: {
    headView,
    progressBar
  },
  data() {
    return {
      title: {
        headText: "Estadísticas",
        subtitle: ""
      },
      subtitleOpt: false,
      myChart: {},
      isEmpty: true,
      isStriped: true,
      isNarrowed: true,
      isLoading: true,
      //dateSelect: "",
      building: "",
      //date: new Date(),
      dateFormat: "D MMM",
      dateOne: "",
      dateTwo: "",
      expCat: [{
        label: "Area común",
        value: "common-area"
      }, {
        label: "Cliente",
        value: "client"
      }],
      category: undefined
    };
  },
  computed: {
    ...mapState(["statCPs", "companyId", "statisticsCheckpointsChart"]),
    dataTable() {
      console.log(this.statCPs);

      if (this.statCPs) {
        return this.statCPs.map(c => {
          let obj = {
            name: c.name,
            wellPercentage: `${(c.welltaks / (c.alltaks || 1)) * 100}`,
            badPercentage: `${(c.badtaks / (c.alltaks || 1)) * 100}`,
            pendingPercentage: `${(c.pendingtaks / (c.alltaks || 1)) * 100}`,
            standbyPercentage: `${(c.standbytaks / (c.alltaks || 1)) * 100}`,
            checkpoint: c._id
          };
          return obj;
        });
      }
      return [];
    },
    dateComp: function () {
      var dateC = this.date.toLocaleDateString();
      return dateC;
    },
    loaderComp: function () {
      if (this.dataTable) {
        return false;
      }
      return true;
    },
    progressBar: function () {
      var obj = {
        wellPercentage: 0,
        wellTotal: 0,
        badPercentage: 0,
        badTotal: 0,
        pendingPercentage: 0,
        pendingTotal: 0,
        standbyPercentage: 0,
        standbyTotal: 0
      };
      console.log(this.statCPs)
      for (let cp of this.statCPs) {
        obj.wellPercentage =
          obj.wellPercentage +
          ((cp.welltaks / cp.alltaks) * 100) / this.statCPs.length;
        obj.wellTotal = obj.wellTotal + cp.welltaks;
        obj.badPercentage =
          obj.badPercentage +
          ((cp.badtaks / cp.alltaks) * 100) / this.statCPs.length;
        obj.badTotal = obj.badTotal + cp.badtaks;
        obj.pendingPercentage =
          obj.pendingPercentage +
          ((cp.pendingtaks / cp.alltaks) * 100) / this.statCPs.length;
        obj.pendingTotal = obj.pendingTotal + cp.pendingtaks;
        obj.standbyPercentage =
          obj.standbyPercentage +
          ((cp.standbytaks / cp.alltaks) * 100) / this.statCPs.length;
        obj.standbyTotal = obj.standbyTotal + cp.standbytaks;
      }
      return obj;
    }
  },
  watch: {
    statisticsCheckpointsChart: function (n) {
      if (!n) return;
      this.isLoading = true;
      console.log(n);
      n.series = this.seriesDataCharts();
      this.createChart(n);
    }
  },
  beforeCreate() {
    // this.$store.commit("activeLoader")
    this.$store.commit("setColorChildren", "statistics");
  },
  beforeDestroy() {
    this.$store.commit("resetColorChildren", "statistics");
    this.$store.commit("activeLoader");
  },
  created() {
    // this.$store.commit("activeLoader")
    this.$nextTick(() => {
      this.$store.dispatch("GETSTATSCHECKPOINT", {
        bussines: this.companyId,
        building: this.building,
        namespace: this.$store.state.namespace
      });
    });
  },
  mounted() { },
  methods: {
    linkToView: function (op) {
      this.$router.push({
        name: "statisticCheckpointBuildings",
        params: { id: op.checkpoint }
      });
    },
    createChart: function (chartdata) {
      this.myChart = new ApexCharts(this.$refs.apexChart, chartdata);
      this.myChart.render();
      this.isLoading = false;
    },
    seriesDataCharts: function () {
      var arr = [];
      var aux = [1, 2, 3, 4];
      for (let n of aux) {
        switch (n) {
          case 1:
            let obj = {
              name: "Bien",
              data: this.statCPs.map(c => {
                return c.welltaks;
              })
            };
            arr.push(obj);
            break;
          case 2:
            let obj2 = {
              name: "Pendiente",
              data: this.statCPs.map(c => {
                return c.pendingtaks;
              })
            };
            arr.push(obj2);
            break;
          case 3:
            let obj3 = {
              name: "Mal",
              data: this.statCPs.map(c => {
                return c.badtaks;
              })
            };
            arr.push(obj3);
            break;
          case 4:
            let obj4 = {
              name: "StandBy",
              data: this.statCPs.map(c => {
                return c.standbytaks;
              })
            };
            arr.push(obj4);
        }
      }
      return arr;
    },
    selectBuilding: function () {
      // this.isLoading = true;
      this.$store.commit("activeLoader");
      var aux_sd = this.dateOne ? new Date(this.dateOne.replace("-", ".")) : new Date();
      var aux_ed = this.dateTwo ? new Date(this.dateTwo.replace("-", ".")) : new Date();
      aux_sd.setHours(0, 0, 0, 0);
      aux_ed.setHours(23, 59, 59, 999);
      this.$nextTick(() => {
        this.$store.dispatch("GETSTATSCHECKPOINT", {
          bussines: this.companyId,
          building: this.building,
          startDate: aux_sd.toISOString(),
          endDate: aux_ed.toISOString(),
          namespace: this.$store.state.namespace,
          category: this.$store.state.namespace === 'experience' ? this.category : undefined
        });
      });
      //usa metodo post del api con campos startDate y endDate
    },
    filterData: function () {
      // this.isLoading = true;
      this.$store.commit("activeLoader");
      var aux_sd = this.dateOne ? new Date(this.dateOne.replace("-", ".")) : new Date();
      var aux_ed = this.dateTwo ? new Date(this.dateTwo.replace("-", ".")) : new Date();
      aux_sd.setHours(0, 0, 0, 0);
      aux_ed.setHours(23, 59, 59, 999);
      this.$nextTick(() => {
        this.$store.dispatch("GETSTATSCHECKPOINT", {
          bussines: this.companyId,
          building: this.building,
          startDate: aux_sd.toISOString(),
          endDate: aux_ed.toISOString(),
          namespace: this.$store.state.namespace,
          category: this.$store.state.namespace === 'experience' ? this.category : undefined
        }).finally(() => {
          this.$store.commit("deactiveLoader");
        });
      });
      //usa metodo post del api con campos startDate y endDate
    },
    selectCategory: function () {
      // this.isLoading = true;
      this.$store.commit("activeLoader");
      var aux_sd = new Date();
      var aux_ed = new Date();
      aux_sd.setHours(0, 0, 0, 0);
      aux_ed.setHours(23, 59, 59, 999);
      this.$nextTick(() => {
        this.$store.dispatch("GETSTATSCHECKPOINT", {
          bussines: this.companyId,
          building: this.building,
          startDate: aux_sd.toISOString(),
          endDate: aux_ed.toISOString(),
          namespace: this.$store.state.namespace,
          category: this.$store.state.namespace === 'experience' ? this.category : undefined
        });
      });
      //usa metodo post del api con campos startDate y endDate
    },
    changeDate: function () {
      //usa metodo post del api con campos startDate y endDate
      // console.log(new Date(this.dateOne.replace("-",".")).toISOString(), new Date(new Date(this.dateTwo.replace("-",".")).setHours(23,0,0,0)).toISOString())
      this.$store.commit("activeLoader");
      this.$store.dispatch("GETSTATSCHECKPOINT", {
        bussines: this.companyId,
        building: this.building,
        startDate: new Date(
          new Date(this.dateOne.replace("-", "."))
        ).toISOString(),
        endDate: new Date(
          new Date(this.dateTwo.replace("-", "."))
        ).toISOString(),
        namespace: this.$store.state.namespace
      });
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    downloadExcel() {
      this.$store.commit("activeLoader");
      var aux_sd = this.dateOne ? new Date(this.dateOne.replace("-", ".")) : new Date();
      var aux_ed = this.dateTwo ? new Date(this.dateTwo.replace("-", ".")) : new Date();
      var aux_sd_format = aux_sd.toLocaleDateString();
      var aux_ed_format = aux_ed.toLocaleDateString();
      this.$store.dispatch("DOWNLOADSTATSCHECKPOINTS", {
        id: this.companyId,
        body: {
          building: this.building,
          startDate: aux_sd.toISOString(),
          endDate: aux_ed.toISOString(),
          namespace: this.$store.state.namespace,
          category: this.$store.state.namespace === 'experience' ? this.category : undefined
        }
      }).then(response => {
        const href = URL.createObjectURL(response.data);
        console.log(response, href);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `Reporte-urbanova-${aux_sd_format}-${aux_ed_format}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      }).catch(err => {
        console.error(err);
      }).finally(fn => {
        this.$store.commit("deactiveLoader");
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/1.settings/variables.scss";

.wrap-statistic {
  height: 100%;
}

.statistics-content {
  margin-top: 4em;
  padding: 2em;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;

  .content__filters {
    width: 100%  !important;
    display: flex !important;
    justify-content: center !important;
    align-items: start !important;
    flex-wrap: wrap !important;
    // padding: 0 5rem;
    gap: 1rem !important;

    // select {
    //   width: 200px;
    //   padding: 0.5rem 1rem;
    //   border: none;
    //   border-bottom: thin solid #cacaca;
    //   background-color: inherit;
    //   font-size: 1rem;
    //   margin: 0 2rem;
    //   color: inherit;

    //   &:active,
    //   &:focus {
    //     outline: none;
    //   }
    // }

    // .filter__date {
    //   color: $mainColorText;
    //   margin-bottom: 1rem;
    //   font-size: 1.2rem;
    // }
  }
}

.dp-stat {
  height: 3em !important;
  width: fit-content !important;
}
.dp-stat > div {
  height: 100% !important;
  & > div {
    height: 100% !important;
  }
}
.input-date {
  padding: 0.5rem 1rem !important;
  font-size: 0.8rem !important;
  border: thin solid #00a699 !important;
  // height: 3em !important;
  height: 100% !important;
}

.charts {
  margin: auto;
}

#myChart {
  display: flex;
  justify-content: center;
}

.table-button {
  height: 55px;
  display: flex;
  justify-content: center;
}

.button-edit {
  border: thin solid #e6e4e6;
  padding: 1rem;
  color: #000000;
  font-weight: bold;
  margin: 0;
}

.data-picker-custom {
  margin: 0;
}

.statistic-view__state {
  // padding-top: 70px;
  // max-width: 1300px;
  width: 85%;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;

  .title-section {
    font-size: 25px;
    font-weight: bold;
    text-align: left;
    padding: 10px 0;
  }

  .content-slideShow {
    padding: 20px;
    border-radius: 4px;
    border: 1px solid #d5d5d5;

    // box-shadow: 0 2px 1px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    &--progress {
      width: 100%;
    }

    &--report {
      width: 32%;
    }
  }
}

.btn-stats {
  font-size: 16px !important;
  border-radius: 4px !important;
  background-color: #50A3FF !important;
  color: #fff !important;
  height: 3em !important;
  padding: 0 1rem !important;
  border: none !important;
  cursor: pointer !important;
  flex-shrink: 0 !important;
}

.btn-filter {
  font-size: 16px !important;
  border-radius: 4px !important;
  background-color: #1abc9c !important;
  color: #fff !important;
  height: 3em !important;
  padding: 0 1rem !important;
  border: none !important;
  cursor: pointer !important;
  flex-shrink: 0 !important;
}

.select-stats {
  max-width: 200px !important;
  margin: 0 !important;
}
</style>
<style lang="scss">
.mx-input {
  padding: 23px 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/StatisticsView.vue